/**
 * LABS: Pippi — the "Report to Pippi" pill in Omni's top bar, next to Ask Lykke (as in the BO). Hidden unless cowork
 * says available. `compact`: the avatar alone, for the phone header.
 */
import { Mic } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePippi } from './pippiHooks';
import s from './Pippi.module.css';

export const PIPPI_AVATAR = '/assets/pippi/pippi-avatar-64.jpg';
export const PIPPI_AVATAR_LG = '/assets/pippi/pippi-avatar-128.jpg';

export function PippiButton({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const p = usePippi();
  if (!p?.available) return null;
  const open = p.ui.mode === 'open';
  return (
    <div className={`${s.pill} ${compact ? s.pillCompact : ''}`} data-pippi-ui>
      <button type="button" className={s.pillMain} aria-expanded={open} aria-haspopup="dialog" onClick={() => p.dispatch({ type: 'toggle' })}>
        <span className={s.pav}>
          <img src={PIPPI_AVATAR} alt="" />
          <span className={`${s.dot} ${p.unread ? s.dotUnread : ''}`} aria-hidden />
        </span>
        <span className={s.pillLabel}>{t('pippi.pill')}</span>
        {p.unread > 0 && <span className={s.count} aria-label={t('pippi.unreadAria', { count: p.unread })}>{p.unread}</span>}
      </button>
      <button
        type="button"
        className={`${s.pillMic} ${p.dictation.active ? s.pillMicOn : ''}`}
        aria-pressed={p.dictation.active}
        aria-label={p.dictation.active ? t('pippi.micStop') : t('pippi.micStart')}
        title={p.dictation.active ? t('pippi.micStop') : t('pippi.micStart')}
        onClick={() => { if (!open) p.dispatch({ type: 'open', tab: 'chat' }); p.dictation.toggle(); }}
      >
        <Mic size={16} aria-hidden />
      </button>
    </div>
  );
}
